import React from 'react';
import styled from '@emotion/styled';
import { withSpacingStyles } from '../withSpacingStyles';
import { Text } from '../text/Text';
import { IconButton } from '../buttons/IconButton';
import { Icon } from '../icons/Icon';

type Props = {
  page: number,
  pageCount: number,
  isLoading?: boolean,
  className?: string,
  dataTest?: string,
  previousPage: Function,
  nextPage: Function,
};

const _TablePagination = ({ page, pageCount, isLoading, previousPage, nextPage, className, dataTest }: Props) => (
  <Pagination className={className}>
    <IconButton
      onClick={previousPage}
      disabled={isLoading || page <= 1}
      icon="ChevronLeft"
      mode="light"
      size="xsmall"
      data-test={`${dataTest}-previous-page`}
    />
    <TextWrapper>{isLoading ? <Icon mx={2} spin name="Spinner" /> : <Text mx={3}>{page}</Text>}</TextWrapper>

    <IconButton
      onClick={nextPage}
      icon="ChevronRight"
      mode="light"
      size="xsmall"
      disabled={isLoading || page >= pageCount}
      data-test={`${dataTest}-next-page`}
    />
  </Pagination>
);

export const TablePagination = withSpacingStyles(_TablePagination);

const Pagination = styled('div')`
  display: flex;
  justify-content: flex-end;
  align-items: center;
`;

const TextWrapper = styled('div')`
  min-width: 35px;
  text-align: center;
`;
